import type { ProductFeature } from '@partful/shared-types';
import { ScreenName } from 'src/App';

export const productLibraryPath: ScreenName = 'product-library';
export const partsCataloguePath: ProductFeature = 'parts-catalogue';
